module.exports = __webpack_public_path__ + "img/qrcode.fe1eecd7.png";